export const documentPrintConfigs = {
  invoice: {
    documentTitle: ({ isGstApplicable }) => (isGstApplicable ? "TAX INVOICE" : "INVOICE"),
    filePrefix: "Invoice",
    numberLabel: "Invoice No",
    dateLabel: "Invoice Date",
    dueLabel: "Due Date",
    partyLabel: "Bill To",
    numberKeys: ["invoiceNumber", "number"],
    dateKeys: ["invoiceDate", "date"],
    dueKeys: ["dueDate"],
  },
  quotation: {
    documentTitle: "QUOTATION",
    filePrefix: "Quotation",
    numberLabel: "Quotation No",
    dateLabel: "Date",
    dueLabel: "Valid Till",
    partyLabel: "Bill To",
    numberKeys: ["quoteNumber", "quotationNumber", "number"],
    dateKeys: ["quoteDate", "quotationDate", "date"],
    dueKeys: ["validTill", "expiryDate", "dueDate"],
  },
  estimate: {
    documentTitle: "ESTIMATE",
    filePrefix: "Estimate",
    numberLabel: "Estimate No",
    dateLabel: "Estimate Date",
    dueLabel: "Expiry Date",
    partyLabel: "Customer",
    numberKeys: ["estimateNumber", "number"],
    dateKeys: ["estimateDate", "date"],
    dueKeys: ["expiryDate", "validTill", "dueDate"],
  },
  purchase_order: {
    documentTitle: "PURCHASE ORDER",
    filePrefix: "PurchaseOrder",
    numberLabel: "PO No",
    dateLabel: "PO Date",
    dueLabel: "Expected Delivery Date",
    partyLabel: "Vendor",
    numberKeys: ["purchaseNumber", "purchaseOrderNumber", "poNumber", "number"],
    dateKeys: ["purchaseDate", "purchaseOrderDate", "poDate", "date"],
    dueKeys: ["expectedDeliveryDate", "deliveryDate", "dueDate"],
  },
  sales_order: {
    documentTitle: "SALES ORDER",
    filePrefix: "SalesOrder",
    numberLabel: "SO No",
    dateLabel: "Order Date",
    dueLabel: "Delivery Date",
    partyLabel: "Customer",
    numberKeys: ["salesOrderNumber", "orderNumber", "number"],
    dateKeys: ["salesOrderDate", "orderDate", "date"],
    dueKeys: ["deliveryDate", "dueDate"],
  },
  delivery_challan: {
    documentTitle: "DELIVERY CHALLAN",
    filePrefix: "DeliveryChallan",
    numberLabel: "Challan No",
    dateLabel: "Challan Date",
    dueLabel: "Delivery Address",
    partyLabel: "Customer",
    numberKeys: ["deliveryChallan", "challanNumber", "number"],
    dateKeys: ["deliveryChallanDate", "challanDate", "date"],
    dueKeys: ["deliveryAddress", "shipAddress1", "dueDate"],
  },
  pro_forma: {
    documentTitle: "PRO FORMA INVOICE",
    filePrefix: "ProForma",
    numberLabel: "Pro Forma No",
    dateLabel: "Pro Forma Date",
    dueLabel: "Valid Till",
    partyLabel: "Customer",
    numberKeys: ["invoiceNumber", "proFormaNumber", "number"],
    dateKeys: ["invoiceDate", "proFormaDate", "date"],
    dueKeys: ["validTill", "dueDate"],
  },
  recurring_invoice: {
    documentTitle: "RECURRING INVOICE",
    filePrefix: "RecurringInvoice",
    numberLabel: "Recurring No",
    dateLabel: "Start Date",
    dueLabel: "Next Invoice Date",
    partyLabel: "Customer",
    numberKeys: ["invoiceNumber", "recurringInvoiceNumber", "number"],
    dateKeys: ["startDate", "invoiceDate", "date"],
    dueKeys: ["nextInvoiceDate", "dueDate"],
  },
  credit_note: {
    documentTitle: "CREDIT NOTE",
    filePrefix: "CreditNote",
    numberLabel: "Credit Note No",
    dateLabel: "Credit Date",
    dueLabel: "Linked Invoice",
    partyLabel: "Customer",
    numberKeys: ["creditNoteNumber", "number"],
    dateKeys: ["creditNoteDate", "date"],
    dueKeys: ["originalInvoiceNumber", "invoiceNumber", "reference"],
  },
  expense: {
    documentTitle: "EXPENSE VOUCHER",
    filePrefix: "Expense",
    numberLabel: "Expense No",
    dateLabel: "Expense Date",
    dueLabel: "Category",
    partyLabel: "Vendor / Payee",
    numberKeys: ["expenseNumber", "invoice", "id"],
    dateKeys: ["expenseDate", "date"],
    dueKeys: ["expenseAccount", "category"],
  },
  purchase: {
    documentTitle: "PURCHASE",
    filePrefix: "Purchase",
    numberLabel: "Purchase No",
    dateLabel: "Purchase Date",
    dueLabel: "Due Date",
    partyLabel: "Vendor",
    numberKeys: ["purchaseNumber", "billsNumber", "number", "id"],
    dateKeys: ["purchaseDate", "billsDate", "date"],
    dueKeys: ["dueDate"],
  },
  payment_receipt: {
    documentTitle: "PAYMENT RECEIPT",
    filePrefix: "PaymentReceipt",
    numberLabel: "Receipt No",
    dateLabel: "Payment Date",
    dueLabel: "Invoice Reference",
    partyLabel: "Customer",
    numberKeys: ["receiptNumber", "paymentNumber", "id"],
    dateKeys: ["paymentDate", "date"],
    dueKeys: ["invoiceNumber", "reference"],
  },
};

export const getDocumentPrintConfig = (documentType = "invoice", overrides = {}) => ({
  ...(documentPrintConfigs[documentType] || documentPrintConfigs.invoice),
  ...overrides,
  documentType,
});
